import { AuthenticationError } from './validators';
export const triggerReload = () => {
    window.location.reload();
};
export const redirectTo = (target) => {
    window.location.href = target;
};
export const getRedirectOrReloadOnError = ({ redirect = redirectTo, reload = triggerReload, } = {}) => (err) => {
    if (err.redirectTarget) {
        redirect(err.redirectTarget);
    }
    else {
        reload();
    }
};
export const redirectOrReloadOnError = getRedirectOrReloadOnError();
export const reloadOrRedirectOnAuthError = (validator, options = {}) => {
    const handler = getRedirectOrReloadOnError(options);
    return context => {
        try {
            return validator(context);
        }
        catch (err) {
            if (err instanceof AuthenticationError) {
                return handler(err);
            }
            throw err;
        }
    };
};
//# sourceMappingURL=helpers.js.map